export default __webpack_public_path__ + "static/media/Ophira-Eisenberg.9f994830.jpg";